// @ts-ignore
import {DateTime} from 'luxon';
import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {TableRecordResult} from "../../model/api/table-record-result";
import {ApiValidation} from "../../model/api/api-validation";
import {Invoice} from "../../model/billing/invoice";
import {ApiFileResponse} from "../../model/api/api-file-response";

export class CrystalclearBillingBackUrl {
  static readonly GET_BILLING_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult> = {
    url: '/api/billing/list',
    type: TableRecordResult
  };
  static readonly GET_BILLING_LIST_DETAILS: CrystalclearBackUrl.UrlConf<TableRecordResult> = {
    url: '/api/billing/list-details',
    type: TableRecordResult
  };
  static readonly GET_BILLING_GENERATE: CrystalclearBackUrl.UrlConf<ApiValidation<Invoice>> = {
    url: '/api/billing/generate',
    type: ApiValidation
  };
  static readonly GET_BILLING_CANCEL: CrystalclearBackUrl.UrlConf<ApiValidation<Invoice>> = {
    url: '/api/billing/cancel',
    type: ApiValidation
  };
  static readonly POST_BILLING_UPDATE_OUTSTANDING: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/billing/updateOutstandingAmount',
    type: ApiValidation
  };
  static readonly GET_BILLING_SAVE_ORDERS: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/billing/save_orders',
    type: ApiValidation
  };
  static readonly GET_BILLING_PAY: CrystalclearBackUrl.UrlConf<ApiValidation<Invoice>> = {
    url: '/api/billing/pay',
    type: ApiValidation
  };
}

